import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';
import { API_ENDPOINTS } from '../constants/api';
import { TIMEOUT_CONFIG } from '../constants/common';

class CCBillService {
  /**
   * Get OAuth access token for CCBill widget
   * @returns {Promise<Object>} Token response
   */
  async getToken() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CCBILL_TOKEN, {});
      return ResponseHandler.handleSuccess(response, 'Token fetched successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to fetch token');
    }
  }
  
  /**
   * Charge using existing payment token
   * @param {Object} chargePayload - Charge payload containing paymentTokenId, clientSubacc, currencyCode, initialPrice, initialPeriod, passThroughInfo, and optionally recurringPrice, recurringPeriod, numRebills
   * @returns {Promise<Object>} Charge response
   */
  async charge(chargePayload) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CCBILL_CHARGE, chargePayload, {
        timeout: TIMEOUT_CONFIG.CCBILL,
      });

      return ResponseHandler.handleSuccess(response, 'Charge completed successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to process charge');
    }
  }

  /**
   * Call CCBill webhook for free trial subscription
   * @param {Object} webhookPayload - Webhook payload containing clientAccnum, clientSubacc, eventType, eventGroupType, and webhook data
   * @returns {Promise<Object>} Webhook response
   */
  async callWebhook(webhookPayload) {
    try {
      const { queryParams, body } = webhookPayload;
      const response = await apiClient.post(
        API_ENDPOINTS.CCBILL_WEBHOOK,
        body,
        {
          params: queryParams,
          timeout: TIMEOUT_CONFIG.CCBILL,
        }
      );

      return ResponseHandler.handleSuccess(response, 'Webhook called successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to call webhook');
    }
  }
}

export default new CCBillService();

